// extracted by mini-css-extract-plugin
module.exports = {"horizontal_loader":"style_horizontal_loader__3ahjU","move_right":"style_move_right__SiGKd"};